import moment from "moment";

import { ChartRangeType } from "../constants";

export const getChartBarColumnsBottomLabels = (
  date: [Date, Date],
  rangeType: ChartRangeType
): Array<string | number> => {
  switch (rangeType) {
    case ChartRangeType.Week:
      return Array.from({ length: 7 }, (_, i) =>
        moment().weekday(i).format("ddd")
      );
    case ChartRangeType.Month:
      return Array.from(
        { length: moment(date[0]).daysInMonth() },
        (_, index) => index + 1
      ).map((day) => day);
    case ChartRangeType.Year:
      return Array.from({ length: 12 }, (_, index) =>
        moment(date[0]).month(index).format("MMM")
      );
    case ChartRangeType.Custom:
      return Array.from(
        { length: moment(date[1]).diff(date[0], "days") + 1 },
        (_, index) => moment(date[0]).add(index, "days").format("DD.MM.YY")
      );
    default:
      return [];
  }
};
